import React from 'react';
import { Helmet } from 'react-helmet-async';

// Per-page SEO tags. Thin wrapper over react-helmet-async so every public page
// can declare a unique <title>, description, canonical, and Open Graph pair in
// one line. Pass `noindex` for non-marketing routes (auth, portal, popout) to
// emit a robots noindex,nofollow meta. Additive metadata only — no page logic.
//
// Notes:
// - CRA is an SPA: these tags are injected into <head> at runtime (visible in
//   DevTools / the rendered DOM), not in the static view-source of index.html.
//   The crawlable baseline defaults live in public/index.html + the App.js
//   Helmet; these per-page tags override them once React mounts.
// - `canonical` should be an absolute URL (https://coloryourvoice.com/...).
// - `defer={false}` is REQUIRED on every <Helmet> in this app, and the default
//   (true) must never be reintroduced. Deferred commits ride
//   requestAnimationFrame, which never fires in a hidden or frame-starved tab
//   — background tabs keep the stale title, crawlers that snapshot the DOM
//   without pumping a frame miss every tag, and no agent-driven browser
//   harness (permanently visibility:hidden) can ever observe the head. That
//   deferral is exactly what made this app's head tags look broken at every
//   level on 2026-08-18 while being fine for real visible-tab users. defer is
//   resolved per INNERMOST Helmet instance (defaultProps stamps true on each),
//   so setting it here does not cover other Helmet call sites — each one
//   carries its own defer={false}.
const SITE = 'https://coloryourvoice.com';

const Seo = ({ title, description, canonical, noindex = false }) => {
	const ogTitle = title;
	const ogDescription = description;
	return (
		<Helmet defer={false}>
			{title && <title>{title}</title>}
			{description && <meta name='description' content={description} />}
			{canonical && <link rel='canonical' href={canonical} />}
			{noindex && <meta name='robots' content='noindex,nofollow' />}
			{title && <meta property='og:title' content={ogTitle} />}
			{description && (
				<meta property='og:description' content={ogDescription} />
			)}
			{canonical && <meta property='og:url' content={canonical} />}
		</Helmet>
	);
};

export { SITE };
export default Seo;
